export const ELEMENT_WIDTH = 175;
export const ELEMENT_HEIGHT = 36;

export const scrollOptions = {
  behavior: 'smooth',
  block: 'start',
};
